import {PaymentMethod} from "./payment-method";
import {CreditCardMapper} from "./credit-card-mapper";

export class PaymentMethodMapper {

  public static map(data: any): PaymentMethod {
    let paymentMethod: PaymentMethod = new PaymentMethod();

    paymentMethod.id = data.id;
    paymentMethod.clientId = data.clients_id;
    paymentMethod.creditCard = CreditCardMapper.map(data.info);
    paymentMethod.active = data.default === 1;

    return paymentMethod;
  }

}
